/* Ian 2026-05-22: Read More toggle for collection description.
   Markup expected:
     <div class="ian-readmore" data-readmore>
       <div class="ian-readmore__content">…</div>
       <button data-readmore-toggle aria-expanded="false">Read more</button>
     </div>
   CSS clamps the content to 4 lines by default. This script hides the
   button when the content isn't actually overflowing, and toggles the
   is-expanded class + button label on click. */

(function () {
  function init() {
    var containers = document.querySelectorAll('[data-readmore]');
    if (!containers.length) return;

    containers.forEach(function (container) {
      var content = container.querySelector('.ian-readmore__content');
      var button = container.querySelector('[data-readmore-toggle]');
      if (!content || !button) return;

      // Defer the overflow check by one frame so layout has settled and
      // any web fonts have applied, avoiding false negatives on first paint.
      requestAnimationFrame(function () {
        var isClipped = content.scrollHeight > content.clientHeight + 1;
        if (!isClipped) {
          button.hidden = true;
          return;
        }

        button.addEventListener('click', function () {
          var expanded = container.classList.toggle('is-expanded');
          button.setAttribute('aria-expanded', expanded ? 'true' : 'false');
          button.textContent = expanded ? 'Read less' : 'Read more';
        });
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
